import connection from '../connection';

export const getMessages = async =>
    connection.get('v1/current_user/notifications');

export const getMessageDetails = async id =>
   connection.get(`v1/current_user/notifications/${id}`);

export const getNewMessages = async =>
    connection.get('v1/current_user/notifications/new_notifications');

export const getSentNotifications = async =>
    connection.get('v1/current_user/notifications/sent_notifications');

export const setNotificationNotRead = async id =>
    connection.post(`v1/current_user/notifications/${id}/set_as_not_read`);

export const hideSender = async id =>
    connection.post(`v1/current_user/notifications/${id}/hide_sender`);

export const hideRecipient = async id =>
    connection.post(`v1/current_user/notifications/${id}/hide_recipient`);
